// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AppstoreAddOutlinedSvg from "@ant-design/icons-svg/es/asn/AppstoreAddOutlined";
import AntdIcon from '../components/AntdIcon';

var AppstoreAddOutlined = function AppstoreAddOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AppstoreAddOutlinedSvg
  }));
};

AppstoreAddOutlined.displayName = 'AppstoreAddOutlined';
export default React.forwardRef(AppstoreAddOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AppstoreAddOutlined.js
// module id = 583
// module chunks = 0